"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xlsx = _interopRequireDefault(require("xlsx"));
var _ProgressBar = _interopRequireDefault(require("@/components/ProgressBar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ProgressUploadExcel',
  components: {
    ProgressBar: _ProgressBar.default
  },
  props: {
    beforeUpload: Function,
    // eslint-disable-line
    onSuccess: Function,
    // eslint-disable-line
    getFileObject: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    uploadApi: Function,
    // 上传API函数
    progressTitle: {
      type: String,
      default: '导入文件'
    },
    size: {
      type: String,
      default: 'default'
    },
    canRetry: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: null
      },
      // 进度条相关数据
      showProgress: false,
      uploadPercentage: 0,
      progressStatus: '准备上传...',
      isUploadError: false,
      isUploadSuccess: false,
      canCancelUpload: true,
      uploadSpeed: '',
      fileSize: '',
      currentFile: null,
      uploadStartTime: null,
      uploadController: null // AbortController for canceling
    };
  },
  methods: {
    generateData: function generateData(_ref) {
      var header = _ref.header,
        results = _ref.results;
      this.excelData.header = header;
      this.excelData.results = results;
      this.onSuccess && this.onSuccess(this.excelData);
    },
    handleDrop: function handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      var files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error('只支持上传一个文件!');
        return;
      }
      var rawFile = files[0];
      if (!this.isExcel(rawFile)) {
        this.$message.error('只支持上传 .xlsx, .xls, .csv 格式的文件');
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover: function handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleUpload: function handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick: function handleClick(e) {
      var files = e.target.files;
      var rawFile = files[0];
      if (!rawFile) return;
      this.getFileObject && this.getFileObject(rawFile);
      this.upload(rawFile);
    },
    upload: function upload(rawFile) {
      this.$refs['excel-upload-input'].value = null;
      this.currentFile = rawFile;
      this.fileSize = this.formatFileSize(rawFile.size);
      if (!this.beforeUpload) {
        this.readerData(rawFile);
        return;
      }

      // 显示进度条
      this.showProgressDialog();

      // 使用Promise包装beforeUpload调用，确保进度显示
      this.handleBeforeUpload(rawFile);
    },
    handleBeforeUpload: function () {
      var _handleBeforeUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(rawFile) {
        var _this = this;
        var result, _progressInterval, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.progressStatus = '正在验证文件...';
              this.uploadPercentage = 10;

              // 小延迟让用户看到进度开始
              _context.n = 1;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 200);
              });
            case 1:
              this.progressStatus = '正在上传文件...';
              this.uploadPercentage = 30;

              // 调用父组件的beforeUpload方法
              result = this.beforeUpload(rawFile); // 模拟上传进度
              _progressInterval = this.simulateUploadProgress();
              if (!(result === false)) {
                _context.n = 2;
                break;
              }
              clearInterval(_progressInterval);
              this.hideProgress();
              return _context.a(2);
            case 2:
              if (!(result && typeof result.then === 'function')) {
                _context.n = 3;
                break;
              }
              _context.n = 3;
              return result;
            case 3:
              clearInterval(_progressInterval);

              // 上传成功
              this.uploadPercentage = 100.00;
              this.progressStatus = '导入完成！';
              this.isUploadSuccess = true;
              this.canCancelUpload = false;

              // 延迟关闭
              setTimeout(function () {
                _this.hideProgress();
              }, 1500);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              // 上传失败
              this.isUploadError = true;
              this.progressStatus = '导入失败：' + (_t.message || '未知错误');
              this.canCancelUpload = false;
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[0, 4]]);
      }));
      function handleBeforeUpload(_x) {
        return _handleBeforeUpload.apply(this, arguments);
      }
      return handleBeforeUpload;
    }(),
    showProgressDialog: function showProgressDialog() {
      this.showProgress = true;
      this.uploadPercentage = 0;
      this.progressStatus = '准备上传...';
      this.isUploadError = false;
      this.isUploadSuccess = false;
      this.canCancelUpload = true;
      this.uploadStartTime = Date.now();
    },
    uploadWithProgress: function () {
      var _uploadWithProgress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(rawFile) {
        var _this2 = this;
        var formData, _progressInterval2, result, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              formData = new FormData();
              formData.append('file', rawFile);
              _context2.p = 1;
              this.uploadController = new AbortController();
              this.progressStatus = '正在上传...';
              this.uploadPercentage = 10;

              // 模拟上传进度（实际项目中应该使用XMLHttpRequest的progress事件）
              _progressInterval2 = this.simulateUploadProgress(); // 调用上传API
              _context2.n = 2;
              return this.uploadApi(formData, {
                signal: this.uploadController.signal,
                onUploadProgress: function onUploadProgress(progressEvent) {
                  if (progressEvent.lengthComputable) {
                    _this2.uploadPercentage = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                    _this2.updateUploadSpeed(progressEvent.loaded);
                  }
                }
              });
            case 2:
              result = _context2.v;
              clearInterval(_progressInterval2);

              // 上传成功
              this.uploadPercentage = 100;
              this.progressStatus = '上传完成！';
              this.isUploadSuccess = true;
              this.canCancelUpload = false;
              this.uploadSpeed = '';

              // 自动关闭进度条
              setTimeout(function () {
                _this2.hideProgress();
                _this2.$message.success('文件导入成功！');
                _this2.$emit('upload-success', result);
              }, 1500);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              clearInterval(progressInterval);
              if (_t2.name === 'AbortError') {
                this.hideProgress();
                this.$message.warning('上传已取消');
              } else {
                this.isUploadError = true;
                this.progressStatus = '上传失败：' + (_t2.message || '未知错误');
                this.canCancelUpload = false;
                this.$message.error('文件上传失败：' + _t2.message);
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function uploadWithProgress(_x2) {
        return _uploadWithProgress.apply(this, arguments);
      }
      return uploadWithProgress;
    }(),
    simulateUploadProgress: function simulateUploadProgress() {
      var _this3 = this;
      return setInterval(function () {
        if (_this3.uploadPercentage < 90 && !_this3.isUploadError && !_this3.isUploadSuccess) {
          _this3.uploadPercentage += Math.random() * 5;
          if (_this3.uploadPercentage > 90) {
            _this3.uploadPercentage = 90;
          }
          // 确保百分比为整数
          _this3.uploadPercentage = Math.round(_this3.uploadPercentage);
        }
      }, 500);
    },
    updateUploadSpeed: function updateUploadSpeed(uploadedBytes) {
      if (this.uploadStartTime) {
        var elapsed = (Date.now() - this.uploadStartTime) / 1000;
        var speed = uploadedBytes / elapsed;
        this.uploadSpeed = this.formatSpeed(speed);
      }
    },
    readerData: function readerData(rawFile) {
      var _this4 = this;
      this.loading = true;
      this.progressStatus = '正在读取文件...';
      this.uploadPercentage = 20;
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          try {
            _this4.uploadPercentage = 60;
            _this4.progressStatus = '正在解析文件...';
            var data = e.target.result;
            var workbook = _xlsx.default.read(data, {
              type: 'array'
            });
            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];
            var header = _this4.getHeaderRow(worksheet);
            var results = _xlsx.default.utils.sheet_to_json(worksheet);
            _this4.uploadPercentage = 90;
            _this4.progressStatus = '处理完成...';
            _this4.generateData({
              header: header,
              results: results
            });
            _this4.loading = false;
            _this4.uploadPercentage = 100;
            _this4.progressStatus = '文件读取完成！';
            _this4.isUploadSuccess = true;
            _this4.canCancelUpload = false;
            setTimeout(function () {
              _this4.hideProgress();
            }, 1000);
            resolve();
          } catch (error) {
            _this4.loading = false;
            _this4.isUploadError = true;
            _this4.progressStatus = '文件解析失败：' + error.message;
            reject(error);
          }
        };
        reader.onerror = function () {
          _this4.loading = false;
          _this4.isUploadError = true;
          _this4.progressStatus = '文件读取失败';
          reject(new Error('文件读取失败'));
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    getHeaderRow: function getHeaderRow(sheet) {
      var headers = [];
      var range = _xlsx.default.utils.decode_range(sheet['!ref']);
      var C;
      var R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell = sheet[_xlsx.default.utils.encode_cell({
          c: C,
          r: R
        })];
        var hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = _xlsx.default.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    isExcel: function isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    // 进度条事件处理
    handleCancelUpload: function handleCancelUpload() {
      if (this.uploadController) {
        this.uploadController.abort();
      }
      this.hideProgress();
    },
    handleRetryUpload: function handleRetryUpload() {
      if (this.currentFile) {
        this.upload(this.currentFile);
      }
    },
    handleCompleteUpload: function handleCompleteUpload() {
      this.hideProgress();
    },
    handleCloseProgress: function handleCloseProgress() {
      this.hideProgress();
    },
    hideProgress: function hideProgress() {
      this.showProgress = false;
      this.uploadPercentage = 0;
      this.progressStatus = '准备上传...';
      this.isUploadError = false;
      this.isUploadSuccess = false;
      this.uploadSpeed = '';
      this.uploadController = null;
    },
    // 工具方法
    formatFileSize: function formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatSpeed: function formatSpeed(bytesPerSecond) {
      if (bytesPerSecond === 0) return '0 B/s';
      var k = 1024;
      var sizes = ['B/s', 'KB/s', 'MB/s', 'GB/s'];
      var i = Math.floor(Math.log(bytesPerSecond) / Math.log(k));
      return parseFloat((bytesPerSecond / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatTime: function formatTime(seconds) {
      if (seconds < 60) return "".concat(Math.round(seconds), "\u79D2");
      if (seconds < 3600) return "".concat(Math.round(seconds / 60), "\u5206\u949F");
      return "".concat(Math.round(seconds / 3600), "\u5C0F\u65F6");
    }
  }
};